<template>
  <div class="documentationDetail" v-if="document">
    <TitleCustom v-if="$cookie.get('language') == 'fr'" v-bind:blueTitle="document.label"></TitleCustom>
    <TitleCustom v-else v-bind:blueTitle="document.label_en"></TitleCustom>
      <b-card-body v-if="document.filetype === 'video' && $cookie.get('language') == 'fr'" >
        <div style="display:inline-block; text-align:center" v-html="document.video">
          {{document.video}}
        </div>
      </b-card-body>
    <b-card-body v-if="document.filetype === 'video'" >
      <div style="display:inline-block; text-align:center" v-html="document.video_en">
        {{document.video_en}}
      </div>
    </b-card-body>
      <b-card-body v-if="document.filetype === 'article' && $cookie.get('language') == 'fr'" v-html="document.article">
        {{document.article}}
      </b-card-body>
      <b-card-body v-else-if="document.filetype === 'article'" v-html="document.article_en">
        {{document.article_en}}
      </b-card-body>
      <b-card-body v-if="document.filetype === 'document'  && $cookie.get('language') == 'fr'">
          {{document.document}}
      </b-card-body>
      <b-card-body v-if="document.filetype === 'document'">
        {{document.document_en}}
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
  import { ADMIN_GET_DOCUMENT_REQUEST } from '../_store/administration/document/actiontypes'
  import TitleCustom from '../components/title'
  import slugify from 'slugify';
  function pdfBlobConvesion(b64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    var byteCharacters = window.atob(b64Data);
    var byteArrays = [];
  
    for ( var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize ) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
    
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
    
      var byteArray = new Uint8Array(byteNumbers);
    
      byteArrays.push(byteArray);
    }
  
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  export default {
    name: 'documentationDetail',
    components: { TitleCustom },
    mounted() {
      console.log("I go for mount")
      this.$store.dispatch(ADMIN_GET_DOCUMENT_REQUEST, this.$route.params.id)
        .then(response => {
          this.document = response.data.document;
          if (this.document.filetype == "document"){
            let document_file = this.document.document;
            if (this.$cookie.get('language') === 'en')
              document_file = this.document.document_en;
            let type = document_file.split(';')[0].split('/')[1];
            let original_type = type;
            const linkSource = document_file;
            const downloadLink = document.createElement("a");
            if (type === 'vnd.openxmlformats-officedocument.presentationml.presentation')
              type = "pptx";
            if (type === 'vnd.openxmlformats-officedocument.wordprocessingml.document')
              type = 'docx';
            const fileName = slugify(this.document.label, '_') + "_" + this.document.id + "." + type;
            let blob_data = pdfBlobConvesion(document_file, original_type);
            downloadLink.href = URL.createObjectURL(blob_data);
            downloadLink.download = fileName;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob_data, fileName);
            }
            else{
              document.body.appendChild(downloadLink);
              downloadLink.click();
            }
            this.$router.push('/documentation/');
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    data() {
      console.log("I go for data")
      return ({
        document: {}
      })
    },
    layout(context) {
      console.log("I go for layour")
      return 'layout'
    },
    methods: {}
  }
</script>
